module.exports = __webpack_public_path__ + "static/media/joberror.dd6ade6b.svg";